import { Link } from "@tanstack/react-router";
import { ArrowRight, TrendingUp, Receipt, Globe2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { SITE_COPY } from "@/lib/siteContent";

const ICONS = [TrendingUp, Receipt, Globe2];

export function InvestSection() {
  const { lang } = useI18n();
  const c = SITE_COPY[lang].invest;

  return (
    <section className="bg-secondary/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">{c.eyebrow}</p>
            <h2 className="mt-3 font-serif text-3xl text-foreground md:text-5xl">{c.title}</h2>
            <p className="mt-3 text-sm text-muted-foreground md:text-base">{c.subtitle}</p>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground shadow-soft transition hover:brightness-110"
          >
            {c.cta} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {c.items.map((b, i) => {
            const Icon = ICONS[i] ?? TrendingUp;
            return (
              <article key={b.title} className="rounded-2xl border border-border bg-card p-7">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-accent/15 text-accent">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 text-lg font-semibold text-foreground">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{b.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
